import React, {Component} from 'react';
import axios from 'axios';
import {SERVER_URL}  from '../Constants';
import auth0Client from '../Auth';
import {ToastContainer, ToastStore} from 'react-toasts';
import DatePicker from "react-datepicker";
const MODE_CHECKIN = 1;
//const MODE_TRANSFER =2;


let venue = null;
class CheckInTransfer extends Component {
    constructor(props) {
      super(props);
        
      console.log(props);
      this.state={
            selectedItems:props.selectedItems,
            mode:props.mode,
            loading:false,
            locations:[],
            disabled:false,
            transferToLocationId: '',
            transferDate: new Date(),
            numItems: (props.selectedItems)? props.selectedItems.length : 0,

        }
    }
    async componentDidMount() {
       
        venue = auth0Client.getDefaultVenue();
        this.loadLocations();
    }
  /// This will load the locations.  
  loadLocations=async()=>{
    // Fetch POST Call to locations endpoint
    
    if(venue===undefined){
        alert('Invalid or missing Venue.  Please log out and log back in')
        return;
      }
     
      try{
          this.setState({loading:true})
        // Load the lostItems for the current default aurport if 
        // no other filters are specified
       
        if(!venue || !venue.objectId) {
        
          return;  
        }
       // let token= await auth0Client.getIdToken();
       
        //console.log(token);
        let urlEndpoint =(this.state.mode===MODE_CHECKIN)? '/Checkinout/checkinLocations' :  '/Checkinout/transferLocations'
        fetch(SERVER_URL + urlEndpoint, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth0Client.getIdToken()}`,
            'venueId': auth0Client.getActiveVenuedId() 
            },
            body:JSON.stringify({
                    airportCds:[],
                    typeCds:[]
                })
            }).then((response) => response.json())
            .then((results) => {
                //console.log(results);
             
                this.setState({
                    locations : results,
                  
                    refreshing:false,
                    loading:false,
                 
                })
            })
            .catch((error) => {
              console.error(error);
              ToastStore.error("An error occured. Please try again :" + error);
              this.setState({
                locations : [],
               
                refreshing:false,
                loading:false,
                
                })
            });
           
          
        
       
             
      }catch(e){
        console.log(e.message);
        ToastStore.error("An error occured. Please try again :" + e.message);
        this.setState({
          lostItems : [],
          locations : [],
          numItems : 0,
          refreshing:false,
          loading:false,
        })
        
         
      }finally{
          //this.setState({ loading: false});
  
      }

}   

onTransferDateChange = date => this.setState({ transferDate :date });

renderToast=()=>{
    return <div>
        <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
    </div>
  }

  renderItems=()=>{
      if (this.state.locations){

      }
  }

  close=()=>{

   
      if (this.props.onClose){
         
          this.props.onClose()
      }
  }

  handleInputChange=(event) =>{
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
   
   
    this.setState({
      [name]: value,
     
    }, );
  
  }
  process=()=>{
    if (this.state.selectedItems.length<=0){
        alert('No items selected');
        return;
      }
      if (this.state.transferToLocationId==='' || this.state.transferToLocationId===undefined){
        alert('No Location Selected');
        return;
      }

      this.batchUpdate();
  }
// batch update
batchUpdate=()=>{
    //  console.log('loading...' + auth0Client.getIdToken());
    
    let uriEndpoint = (this.state.mode===MODE_CHECKIN) ? '/Checkinout/checkInItems' : '/Checkinout/transferItems';
  
    axios.post(SERVER_URL +  uriEndpoint,{
        itemIds:this.state.selectedItems,
        location:{_id : this.state.transferToLocationId},
        transferDate: this.state.transferDate
     }, 
     {
      headers: { 
        'Authorization': `Bearer ${auth0Client.getIdToken()}`,
        'venueId': auth0Client.getActiveVenuedId() 
      }
    }).then((res)=>{
      
      if (res.status !== 200) {
        //place your reentry code
        console.log(res);
        ToastStore.error("An error occured. Please try again" );
       
       }else{
        ToastStore.success('Update Successfull!');
        if (this.props.onCheckInTransferCompleted) { this.props.onCheckInTransferCompleted(this.state.selectedItems)}
       }
  
  
      // reload
       
  
      }).catch((e)=>{ 
        //console.log("error " + e)
        ToastStore.error("An error occured. " + e.message);
      });
  
  }

    render(){

        return(
            <div style={{width:'700px', height:'400px'}}>
                
              <h5>Check-In And Transfer </h5>
              <small>{this.state.numItems + ' '} item(s) will be checked or transfered to the following:</small>
            <br/><br/><hr/>

            <br/>
            <div className='form-row '>
               <div className='col-3 text-right'> 
                     <label htmlFor="billTypeCode" className='text-primary'> Select Location:</label>
               </div>
                <div className='col-9 text-center'> 
                   <select 
                        className="custom-select"
                        type="text"
                        name="transferToLocationId"
                        onChange={this.handleInputChange}
                        value={this.state.transferToLocationId}
                    >   
                      <option value=""></option>
                        {this.state.locations.map(item=>{
                            return (
                                <option value={item._id}>{ item.name + ' (' + item.description + ')'}</option>
                            )
                        })}
                   </select>
                </div>
            </div>
            <br/>
            <div className="form-row">
                <div className='col-3 text-right'> 
                        <label htmlFor="billTypeCode" className='text-primary'> Date:</label>
                </div>
                <div className="col-9">
               
                                    <DatePicker
                                        className="form-control"
                                        onChange={this.onTransferDateChange}
                                        name="transferDate"
                                        selected={this.state.transferDate}
                                    />
                </div>
            </div>

                <br/>
           <div className='form-row ' style={{marginTop:'100px'}}>
              
                <div className='col-4 text-center'>
                    <button
                    disabled={this.state.disabled }
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => {this.close()}}>
                    Close
                    </button>
             
                </div>
                <div className='col-4 text-center'>
                  
                  </div>

                <div className='col-4 text-right'>
                    <button
                    disabled={(this.state.selectedItems.length ===0 || this.state.transferToLocationId==='') }
                    className="btn btn-outline-success btn-sm"
                    onClick={() => {this.process()}}>
                    Process
                    </button>
             
                </div>
              
             </div>


                {this.renderToast()}
            </div>
        )

    }

}

export default CheckInTransfer